<template>
  <a-form-model ref="form" :model="form.data" :rules="form.rules">
    <a-form-model-item label="地区" prop="locations">
      <a-select
        mode="multiple"
        v-model="form.data.locations"
        multiple
        placeholder="请选择">
        <a-select-option
          v-for="item in location.data"
          :key="item"
          :title="item"
          :value="item">
          {{ item }}
        </a-select-option>
      </a-select>
    </a-form-model-item>
    <a-form-model-item label="首重" prop="baseWeight">
      <a-input-number v-model="form.data.baseWeight"/>
    </a-form-model-item>
    <a-form-model-item label="运费" prop="postage">
      <a-input-number v-model="form.data.postage"/>
    </a-form-model-item>
    <!--    <a-form-model-item label="续重" prop="unitWeight">-->
    <!--      <a-input-number v-model="form.data.unitWeight"/>-->
    <!--    </a-form-model-item>-->
    <!--    <a-form-model-item label="续费" prop="unitPostage">-->
    <!--      <a-input-number v-model="form.data.unitPostage"/>-->
    <!--    </a-form-model-item>-->
    <a-form-model-item label="货币单位" prop="currencyCode">
      <a-select
        v-model="form.data.currencyCode"
        placeholder="请选择">
        <a-select-option
          v-for="item in currencyCode.data"
          :key="item"
          :title="item"
          :value="item">
          {{ item }}
        </a-select-option>
      </a-select>
    </a-form-model-item>
    <a-form-model-item>
      <a-space>
        <a-button type="primary" v-if="!transportInfoId" @click="onAdd">创建</a-button>
        <a-button type="primary" v-if="transportInfoId" @click="onUpdate">更新</a-button>
        <a-button @click="onCancel">{{ $t('CANCEL') || '取消' }}</a-button>
      </a-space>
    </a-form-model-item>
  </a-form-model>
</template>

<script>
import {
  _queryWebsiteTransportInfo,
  _addWebsiteTransportInfo,
  _updateWebsiteTransportInfo,
} from '@/api/websiteTransportInfoApi';

async function getTransportInfo() {
  const result = await _queryWebsiteTransportInfo(this.transportInfoId);
  if (result) {
    this.form.data.locations = result.locations ? result.locations.split(', ') : [];
    this.form.data.baseWeight = result.baseWeight;
    this.form.data.postage = result.postage;
    this.form.data.unitWeight = result.unitWeight;
    this.form.data.unitPostage = result.unitPostage;
    this.form.data.currencyCode = result.currencyCode;
  }
}

async function onAdd() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _addWebsiteTransportInfo({
        locations: this.form.data.locations.join(', '),
        baseWeight: this.form.data.baseWeight,
        postage: this.form.data.postage,
        unitWeight: this.form.data.unitWeight,
        unitPostage: this.form.data.unitPostage,
        currencyCode: this.form.data.currencyCode,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success('添加成功');
          this.onSubmitHandler();
        }
      }
    }
  });
}

async function onUpdate() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _updateWebsiteTransportInfo(this.transportInfoId, {
        locations: this.form.data.locations.join(', '),
        baseWeight: this.form.data.baseWeight,
        postage: this.form.data.postage,
        unitWeight: this.form.data.unitWeight,
        unitPostage: this.form.data.unitPostage,
        currencyCode: this.form.data.currencyCode,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success('更新成功');
          this.onSubmitHandler();
        }
      }
    }
  });
}

function onCancel() {
  if (this.onCancelHandler) {
    this.onCancelHandler();
  }
}

export default {
  name: 'WebsiteTransportInfoEdit',
  props: {
    transportInfoId: String,
    onSubmitHandler: Function,
    onCancelHandler: Function,
  },
  watch: {
    transportInfoId() {
      if (this.transportInfoId) {
        this.getTransportInfo();
      }
    },
  },
  methods: {
    onAdd,
    onUpdate,
    onCancel,
    getTransportInfo,
  },
  data() {
    return {
      location: {
        data: ['阿富汗', '阿尔巴尼亚', '阿尔及利亚', '美属萨摩亚群岛', '安道尔', '安哥拉', '安圭拉', '安提瓜和巴布达', '阿根廷', '亚美尼亚', '阿鲁巴', '澳大利亚', '奥地利', '阿塞拜疆', '巴哈马', '巴林', '孟加拉国', '巴巴多斯',
          '白俄罗斯', '比利时', '伯利兹', '贝宁', '百慕大', '不丹', '玻利维亚', '博内尔岛', '波斯尼亚和黑塞哥维那', '博茨瓦纳', '巴西', '汶莱', '保加利亚', '布基纳法索', '布隆迪', '柬埔寨', '喀麦隆', '加拿大', '加那利群岛',
          '佛得角', '开曼群岛', '中非共和国', '乍得', '智利', '中国大陆', '哥伦比亚', '科摩罗', '刚果', '刚果民主共和国', '库克群岛', '哥斯达黎加', '科特迪瓦', '克罗地亚', '库拉索岛', '塞浦路斯', '捷克共和国', '丹麦',
          '吉布提', '多米尼克', '多米尼加共和国', '厄瓜多尔', '埃及', '萨尔瓦多', '赤道几内亚', '厄立特里亚', '爱沙尼亚', '埃塞俄比亚', '福克兰群岛', '法罗群岛', '斐济', '芬兰', '法国', '法属圭亚那', '法属波利尼西亚',
          '加蓬', '冈比亚', '格鲁吉亚', '德国', '加纳', '直布罗陀', '希腊', '格陵兰', '格林纳达', '瓜德罗普', '关岛', '危地马拉', '根西岛', '几内亚', '几内亚比绍', '英属圭亚那', '海地', '洪都拉斯', '香港', '匈牙利',
          '冰岛', '印度', '印度尼西亚', '伊拉克', '爱尔兰', '以色列', '意大利', '牙买加', '日本', '泽西岛', '约旦', '哈萨克斯坦', '肯尼亚', '基里巴斯', '科索沃', '科威特', '吉尔吉斯坦', '老挝', '拉脱维亚', '黎巴嫩',
          '莱索托', '利比里亚', '利比亚', '列支敦士登', '立陶宛', '卢森堡', '澳门', '马其顿', '马达加斯加', '马拉维', '马来西亚', '马尔代夫', '马里', '马尔他', '马绍尔群岛', '马提尼克岛', '毛里塔尼亚', '毛里求斯',
          '马约特岛', '墨西哥', '摩尔多瓦', '摩纳哥', '蒙古', '黑山共和国', '蒙特塞拉特岛', '摩洛哥', '莫桑比克', '缅甸', '纳米比亚', '瑙鲁', '尼泊尔', '荷兰', '新喀里多尼亚', '新西兰', '尼加拉瓜', '尼日尔', '尼日利亚',
          '纽埃岛', '北马里亚纳群岛', '挪威', '阿曼', '巴基斯坦', '巴拿马', '巴布亚新几内亚', '巴拉圭', '秘鲁', '菲律宾', '波兰', '葡萄牙', '波多黎各', '卡塔尔', '韩国', '留尼旺岛', '罗马尼亚', '俄罗斯', '卢旺达',
          '圣基茨和尼维斯', '圣卢西亚', '圣马丁', '萨摩亚群岛', '圣多美和普林西比', '沙特阿拉伯', '塞内加尔', '塞尔维亚', '塞舌尔', '塞拉利昂', '新加坡', '斯洛伐克', '斯洛文尼亚', '所罗门群岛', '索马里', '南非', '西班牙',
          '斯里兰卡', '苏里南', '斯威士兰', '瑞典', '瑞士', '台湾', '塔吉克斯坦', '坦桑尼亚', '泰国', '东帝汶', '多哥', '汤加', '特立尼达和多巴哥', '突尼斯', '土耳其', '特克斯和凯科斯群岛', '图瓦鲁', '乌干达', '乌克兰',
          '阿拉伯联合酋长国', '英国', '美国', '乌拉圭', '乌兹别克斯坦', '瓦努阿图', '委内瑞拉', '越南', '英属维尔京群岛', '美属维尔京群岛', '也门', '赞比亚', '津巴布韦', '海峡群岛', '古巴', '朝鲜', '塞班岛', '南苏丹',
          '圣巴托洛缪岛', '圣克罗伊岛', '圣尤斯特歇斯', '圣赫勒拿岛', '圣约翰岛', '叙利亚', '苏丹', '圣文森特和格林纳丁斯', '圣托马斯岛', '塔希提岛', '伊朗'],
      },
      currencyCode: {
        data: ['EUR', 'USD', 'CNY', 'GBP'],
      },
      form: {
        data: {
          locations: [],
          baseWeight: 0,
          postage: 0,
          unitWeight: 0,
          unitPostage: 0,
          currencyCode: '',
        },
        rules: {
          locations: [{ required: true, trigger: 'blur' }],
          baseWeight: [{ required: true, trigger: 'blur' }],
          postage: [{ required: true, trigger: 'blur' }],
          unitWeight: [{ required: true, trigger: 'blur' }],
          unitPostage: [{ required: true, trigger: 'blur' }],
          currencyCode: [{ required: true, trigger: 'blur' }],
        },
        title: '',
      },
    };
  },
  created() {
    if (this.transportInfoId) {
      this.getTransportInfo();
    }
  },
};
</script>
